import { render, staticRenderFns } from "./callai-team.vue?vue&type=template&id=0af9bf7c&lang=pug&"
import script from "./callai-team.vue?vue&type=script&lang=js&"
export * from "./callai-team.vue?vue&type=script&lang=js&"
import style0 from "./callai-team.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports